module.exports = __webpack_public_path__ + "static/img/about_fw_4.2b98a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about_fw_4.png
// module id = wZI2
// module chunks = 1